<template>
  <div class="footer-wrapper" >

    <div id="contact-footer"></div>

    <div class="footer-padding">
      <div class="contact-form-inputs">
        <h1 class="heading">MikMak launches Attach for alcohol eCommerce</h1>
        <img class="whitepaper-image" src="">
        <h2 class="sub-heading">By 2023, the alcohol eCommerce industry is suspected to be a $6 ­- $9B market in the US. MikMak Attach for alcohol helps beer, wine and spirits brands with: </h2>
        <h2 class="sub-heading"><b> Connecting your product inventory to digital media<br> </b> With MikMak, ensure your digital media only showcases retailers and marketplaces that have your SKU in stock </h2>
        <h2 class="sub-heading"><b> Optimizing your content for eCommerce<br></b> Control your Product Detail Page Experiences with MikMak, ensure no competitors surface, increase CTR and time spent </h2>
        <h2 class="sub-heading"><b> Building & owning your shopper audiences<br></b> With MikMak, measure from impression through to sale, access retailer specific, audience data in your CMP/Ads Manager for look alike prospecting and retargeting, implement DR targeting with niche audiences to drive bottom line results </h2>
      </div>

      <a href="#contact-footer-form" @click="clickedRequestDemoButton('alcohol-whitepaper')" class="attach-item-request-demo-button">Request a demo</a>

      <div class="logo-wrapper">
        <img src="https://attach-videos.s3.amazonaws.com/cartLogo-amazon.png" class="logo-image">
        <img src="https://attach-videos.s3.amazonaws.com/cartLogo-cocktail-courier.png" class="logo-image">
        <img src="https://attach-videos.s3.amazonaws.com/cartLogo-drizly.png" class="logo-image">
        <img src="https://attach-videos.s3.amazonaws.com/cartLogo-gopuff.png" class="logo-image">
        <img src="https://attach-videos.s3.amazonaws.com/cartLogo-instacart.png" class="logo-image">
        <img src="https://attach-videos.s3.amazonaws.com/cartLogo-kroger.png" class="logo-image">
        <img src="https://attach-videos.s3.amazonaws.com/cartLogo-minibar.png" class="logo-image">
        <img src="https://attach-videos.s3.amazonaws.com/cartLogo-target.png" alt="target" class="logo-image">
        <img src="https://attach-videos.s3.amazonaws.com/cartLogo-reserve-bar.png" class="logo-image">
        <img src="https://attach-videos.s3.amazonaws.com/cartLogo-walmart.png" class="logo-image">
        <img src="https://attach-videos.s3.amazonaws.com/cartLogo-walmart-grocery.png" class="logo-image">
        <img src="https://attach-videos.s3.amazonaws.com/cartLogo-winecom.png" class="logo-image">
      </div>

      <div class="product-demos">
        <span class="product-demo">
          <img src="../../../assets/iphone-7-white.png" class="product-item-image-overlay">
          <video src="https://attach-videos.s3.amazonaws.com/avXmMnrRgmRnVFTceZ8K_patron_screencap.mp4" muted playsinline autoplay loop class="product-demo-video"></video>
        </span>
      </div>

    </div>

    <Footer id="contact-footer-form" :hideFooterPadding="true" :customHeaderText="'Contact MikMak for a Demo'"></Footer>

  </div>
</template>

<script>

import eventDispatcher from '../../../events/dispatch'
import facebookEvent from '../../../events/facebookEvent'
import linkedInEvent from '../../../events/linkedInEvent'
import Footer from '../Footer/Footer'

export default {
  data() {
    return {}
  },
  mounted() {
    this.landingPageEvent()
  },
  components: {
    Footer
  },
  methods: {
    landingPageEvent() {
      facebookEvent('ViewContent', {
        source: 'alcohol'
      })
      linkedInEvent('alcohol')
    },
    clickedRequestDemoButton(demo) {
      let message = `Requested demo from Attach industry/solution page Alcohol Whitepaper`

      if (!window.mmProductInterests) window.mmProductInterests = []
      window.mmProductInterests.push(message)

      eventDispatcher('requestDemoClicked', {
        sourceOfDemo: demo
      })

      this.resetScroll()
    },
    resetScroll() {
      setTimeout(() => {
        window.scrollBy(0, -48)
      }, 10)
    }
  },
  computed: {},
  watch: {}
}
</script>

<style scoped>

.footer-wrapper {
  background: rgba(0, 0, 0, 0.05);
  padding: 60px 24px 24px 24px;
}

.footer-padding {
  display: block;
  max-width: 600px;
  margin: 0 auto;
}

@media only screen and (max-width: 550px) {
  .footer-padding {
    width: 100%;
  }
}

.heading {
  font-weight: normal;
  font-family: "Work Sans", sans-serif;
  font-size: 32px;
  color: #333;
  text-align: center;
  margin: 0 auto;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.sub-heading {
  font-weight: normal;
  font-family: "Work Sans", sans-serif;
  font-size: 14px;
  color: #3e3e3e;
  text-align: center;
  margin: 8px auto;
  margin-bottom: 24px;
  max-width: 80%;
}

@media only screen and (max-width: 550px) {
  .sub-heading {
    max-width: 100%;
  }
}

#contact-footer {
  height: 80px;
}

.logo-wrapper {
  display: block;
  width: 100%;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  margin-top: 24px;
}

.logo-image {
  display: inline-block;
  width: 100px;
  margin: 12px;
}

.product-demos {
  display: block;
  text-align: center;
}

.product-demo {
  display: inline-block;
  position: relative;
}

.product-item-image-overlay {
  width: 275px;
  margin: 24px;
  display: inline-block;
  margin-bottom: 0px;
}

@media only screen and (max-width: 650px) {
  .product-item-image-overlay {
    width: 275px;
  }
}

.product-demo-video {
  display: block;
  position: absolute;
  width: 243px;
  height: 427px;
  margin-top: -503px;
  margin-left: 41px;
  border: 1px solid black;
  background: black;
}

@media only screen and (max-width: 650px) {
  .product-demo-video {
    display: block;
    position: absolute;
    width: 240px;
    height: 428px;
    margin-top: -505px;
    margin-left: 38px;
    border: 1px solid black;
  }
}

.attach-item-request-demo-button {
  background: #409dd4;
  background: #00a9bc;
  background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00a9bc', endColorstr='#00bfbd',GradientType=1 );
  color: white;
  font-size: 22px;
  text-align: center;
  padding: 8px;
  border-radius: 3px;
  margin-top: 24px;
  display: block;
  cursor: pointer;
  box-shadow: 0px 2px 6px #00000024;
  font-weight: lighter;
  text-decoration: none;
  margin: 24px auto;
  letter-spacing: 2px;
  max-width: 320px;
}

</style>



// WEBPACK FOOTER //
// Alcohol.vue?043630e4